import { connect } from "react-redux";
import ToggleQandA from "./page/GetQuestion";
import { fetchQuestions } from "./store/action";
import { useEffect } from "react";
import { VideoDetailProps } from "../video_detail/store/actionType";
interface OwnProps{
    onClose: () => void;
    videoData: VideoDetailProps
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & OwnProps;
const QuestionAndAnswer: React.FC<Props> = ({onClose, onFetchQuestions,videoData, questionState }) => {
   useEffect(() => {
      onFetchQuestions(videoData.id.toString() ?? "");
    }, []);
  return (
    <div className="">
      <ToggleQandA onClose={onClose} questionData={questionState?.questions} videoData={videoData}/>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  questionState: state.questions?.questionsState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchQuestions: (video_id:string) => dispatch(fetchQuestions(video_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionAndAnswer);
